/**
 * Inservice External Integrations
 * Inservice external integrations API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ConnectedVirtualLocationIntegrationDto { 
    id: string;
    realId: string;
    /**
     * Only available to admin? Should be taken from token for a regular user
     */
    userId: string;
    provider: ConnectedVirtualLocationIntegrationDto.ProviderEnum;
}
export namespace ConnectedVirtualLocationIntegrationDto {
    export type ProviderEnum = 'office365';
    export const ProviderEnum = {
        Office365: 'office365' as ProviderEnum
    };
}


